import "./steps.css";

const Steps = () => {
  return (
    <div className="steps">
      <h2 className="steps__header home-headers">Create QR Code in 4 Steps</h2>
      <div className="steps__container">
        <div className="steps__container__step">
          <img
            src="https://i.imgur.com/A3fM6TO.png"
            alt=""
            className="steps__container__step__img"
          />
          <div className="steps__container__step__number">Step 1</div>
          <p>Signup for Free</p>
        </div>
        <div className="steps__container__step">
          <img
            src="https://i.imgur.com/3YwR2oo.png"
            alt=""
            className="steps__container__step__img"
          />
          <div className="steps__container__step__number">Step 2</div>
          <p>Choose QR Type</p>
        </div>
        <div className="steps__container__step">
          <img
            src="https://i.imgur.com/Cyolyyb.png"
            alt=""
            className="steps__container__step__img"
          />
          <div className="steps__container__step__number">Step 3</div>
          <p>Enter the URL</p>
        </div>
        <div className="steps__container__step">
          <img
            src="https://i.imgur.com/tul8Cm9.png"
            alt=""
            className="steps__container__step__img"
          />
          <div className="steps__container__step__number">Step 4</div>
          <p>Customize & Download</p>
        </div>
      </div>
    </div>
  );
};

export default Steps;
